.main {
  width: 100%;
}
